import { Box } from "@mui/material";
import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import { useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";

import Text from "./text/Text";
import { btc, payVia, payViaMsg, sats } from "./messages";
import SelectPayViaModal from "./SelectPayViaModal";
import { walletIconBlue } from "./images";
import { CustomPopper } from "./popper/Popper";

function SelectPayVia(props) {
  const { currency, setIsPayViaOpen, paymentMethods } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleAnchor = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseAnchor = (e) => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box className="pay-via-button">
        <Text
          font="semibold"
          size={16}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          {payVia}
          <ErrorIcon
            aria-describedby={"account-fee"}
            sx={{
              height: "18px",
              width: "18px",
              color: "#A4A9B7 !important",
              marginLeft: "4px !important",
            }}
            onClick={(e) => handleAnchor(e)}
          />
          <CustomPopper
            id="account-fee"
            disablePortal={true}
            open={anchorEl}
            anchorEl={anchorEl}
            position="bottom"
            handleClose={(e) => handleCloseAnchor(e)}
            sx={{ width: "332px" }}
          >
            <Text variant="inherit" font="regular" size={16}>
              {payViaMsg}
            </Text>
          </CustomPopper>
        </Text>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            cursor: "pointer",
          }}
          onClick={() => {
            if (paymentMethods.length > 1) setIsPayViaOpen(true);
          }}
        >
          <img src={walletIconBlue} height={20} width={20} alt="wallet icon" />
          <Text font="semibold" size={16}>
            {currency === sats ? btc : currency}
          </Text>
          {paymentMethods.length > 1 && (
            <KeyboardArrowDownOutlined
              sx={{
                color: "#848B9E",
              }}
            />
          )}
        </Box>
        <SelectPayViaModal {...props} />
      </Box>
    </>
  );
}

export default SelectPayVia;
